import "./GraphNode.css"
import { FunctionComponent } from "react"
import { Handle, NodeProps, useReactFlow, useStoreApi } from "reactflow"
import { GroupNodeData } from "@store/services/converter/types"
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen"
import OpenInFullIcon from "@mui/icons-material/OpenInFull"
import { GraphDataViewModel } from "@features/graph/graphViewModel"
import { graphGroupCollapseExpand } from "@features/graph/handlers/graphGroupCollapseExpand"
import NodeContainer from "@features/graph/node/NodeContainer"

const fontSize = 10

export const GroupNode: FunctionComponent<NodeProps<GroupNodeData>> = (props) => {
  const flowStore = useStoreApi()
  const { fitView } = useReactFlow()
  const target =
    props.data.group.isCollapsed && props.targetPosition ? (
      <Handle type="target" position={props.targetPosition} isConnectable={props.isConnectable} />
    ) : (
      ""
    )
  const source =
    props.data.group.isCollapsed && props.sourcePosition ? (
      <Handle
        type="source"
        id="a"
        position={props.sourcePosition}
        isConnectable={props.isConnectable}
      />
    ) : (
      ""
    )
  const label = props.data.group.isCollapsed ? `${props.data.group.label}` : props.data.group.label

  const icon = props.data.group.isCollapsed ? (
    <OpenInFullIcon sx={{ fontSize }} />
  ) : (
    <CloseFullscreenIcon sx={{ fontSize }} />
  )

  const handleClick = () => {
    if (!GraphDataViewModel.data) {
      return
    }
    GraphDataViewModel.isExpandingIconClicked = true
    const graphData = GraphDataViewModel.data
    graphGroupCollapseExpand(props.data, graphData, flowStore)
    setTimeout(() => fitView({ nodes: [props], duration: 0, maxZoom: 1 }), 0)
  }
  const gigante = import.meta.env.VITE_FF_GIANT_OUTER == "true"
  return (
    <NodeContainer {...props}>
      <div
        className={
          props.data.group.isCollapsed
            ? !props.data.group.parent && gigante
              ? "collapsed-gigante"
              : "collapsed"
            : "expanded"
        }
        style={{ width: "100%", height: "100%" }}
      >
        {target}
        <div
          style={{
            color: pickLabelColor(props.data.group.color, "#FFF", "#000"),
            fontSize: "16px",
            padding: 10,
            // wordBreak: "break-all",
          }}
        >
          <b>{label}</b>
        </div>

        <div
          className={
            !props.data.group.parent
              ? props.data.group.isCollapsed && gigante
                ? "group-node-ec-button-gigante"
                : "group-node-ec-button"
              : "group-node-ec-button"
          }
          onClick={handleClick}
        >
          {icon}
        </div>
        {source}
      </div>
    </NodeContainer>
  )
}

const pickLabelColor = (bgColor: string, lightColor: string, darkColor: string) => {
  // https://stackoverflow.com/a/41491220
  const color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor
  const r = parseInt(color.substring(0, 2), 16) // hexToR
  const g = parseInt(color.substring(2, 4), 16) // hexToG
  const b = parseInt(color.substring(4, 6), 16) // hexToB
  const uicolors = [r / 255, g / 255, b / 255]
  const c = uicolors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92
    }
    return Math.pow((col + 0.055) / 1.055, 2.4)
  })
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  const L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]
  return L > 0.179 ? darkColor : lightColor
}
